import JInfoBox from '@atoms/JInfoBox';
import Jpaper from '@atoms/JPaper';
import { User } from '@candidates/models/dto/get-one-candidate.dto';
import { formatDate } from '@lib/dateUtils';
import Address from '@models/address';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { DividerWithMarginStyled } from '@styled/divider-with-margin.styled';
import CVDownload from '../atoms/CVDownload';
import { useTranslation } from 'react-i18next';

interface UserInfosProps {
  headline?: string;
  cvFileUrl?: string;
  user?: User;
}

const UserInfos = ({ headline, cvFileUrl, user }: UserInfosProps) => {
  const { t } = useTranslation();
  return (
    <Jpaper attr={{ fullHeight: true }}>
      <Stack direction="row" pt={2} px={2} gap={2} alignItems={'center'}>
        <Avatar
          data-qa="avatar"
          sx={{ height: 64, width: 64 }}
          alt={user?.firstname}
          src={user?.avatarUrl}
        />
        <Box>
          <Typography data-qa="full-name" variant="h3">
            {user?.firstname} {user?.lastname}
          </Typography>
          <Typography variant="caption">{headline}</Typography>
        </Box>
      </Stack>
      <DividerWithMarginStyled />
      <Stack gap={1} p={2}>
        <JInfoBox
          label={t('BIRTHDATE')}
          value={formatDate(user?.birthdate ?? null)}
        />

        <JInfoBox label={t('ADDRESS')} value={user?.mobilePhone} />

        <JInfoBox label={t('EMAIL')} value={user?.email} />

        <JInfoBox
          label={t('PHONE_NUMBER')}
          value={formatAddress(user?.address)}
        />

        {cvFileUrl && <CVDownload link={cvFileUrl} profile={'test'} />}
      </Stack>
    </Jpaper>
  );
};

export default UserInfos;

const formatAddress = (address: Address | undefined): string | null => {
  if (!address) return null;

  const street = address.street ?? '';
  const cityName = address.city?.name ?? address.cityName ?? '';
  const country = address.country?.name ?? '';

  // If both the street and city name are empty, return the address's cityName property.
  // Otherwise, return the formatted address string.
  return `${street} ${cityName} ${country}`;
};
